import { render } from "./SongView.vue?vue&type=template&id=0fcf3235&scoped=true&ts=true"
import script from "./SongView.vue?vue&type=script&lang=ts"
export * from "./SongView.vue?vue&type=script&lang=ts"

import "./SongView.vue?vue&type=style&index=0&id=0fcf3235&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Roshaw\\WebstormProjects\\random-song\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcf3235"]])

export default __exports__